/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import omit from 'lodash/omit';

import { formatEntityTypes } from 'exploreDataFormatterFunctions';
import { getLeafIdFromHierarchyPath } from 'hierarchyUtils';
import {
  GET_ARCHIVED_DATA,
  GET_ARCHIVED_DATA_FAILURE,
  GET_ARCHIVED_DATA_SUCCESS,
  ARCHIVE_HIERARCHY_ITEM,
  DELETE_HIERARCHY_ITEM,
  RESTORE_HIERARCHY_ITEM,
  ARCHIVE_HIERARCHY_ITEM_FAILURE,
  DELETE_HIERARCHY_ITEM_FAILURE,
  RESTORE_HIERARCHY_ITEM_FAILURE,
  ARCHIVE_HIERARCHY_ITEM_SUCCESS,
  RESTORE_HIERARCHY_ITEM_SUCCESS,
  DELETE_HIERARCHY_ITEM_SUCCESS,
} from 'archivesActionCreators';
// reducer

export const archivedHierarchyItemsReducer = (
  state = { data: {}, fetchingData: false },
  action
) => {
  switch (action.type) {
    case GET_ARCHIVED_DATA:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_ARCHIVED_DATA_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_ARCHIVED_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(formatEntityTypes(action.payload.results), 'uuid'),
        serverData: keyBy(action.payload.results, 'uuid'),
      };
    case ARCHIVE_HIERARCHY_ITEM:
    case RESTORE_HIERARCHY_ITEM:
    case DELETE_HIERARCHY_ITEM:
      return {
        ...state,
        updatingData: true,
        updateDataError: null,
      };
    case ARCHIVE_HIERARCHY_ITEM_FAILURE:
    case RESTORE_HIERARCHY_ITEM_FAILURE:
    case DELETE_HIERARCHY_ITEM_FAILURE:
      return {
        ...state,
        updatingData: false,
        updateDataError: action.payload,
      };
    case ARCHIVE_HIERARCHY_ITEM_SUCCESS:
      return {
        ...state,
        updatingData: false,
      };
    case RESTORE_HIERARCHY_ITEM_SUCCESS:
    case DELETE_HIERARCHY_ITEM_SUCCESS:
      return {
        ...state,
        updatingData: false,
        // remove the entity type passed (make sure to get the leaf part of the hierarchy path string, which is the key for the data grouping)
        data: omit(state.data, [getLeafIdFromHierarchyPath(action.payload)]),
        serverData: omit(state.data, [getLeafIdFromHierarchyPath(action.payload)]),
      };
    default:
      return state;
  }
};

export const getArchivedHierarchyItems = state =>
  Object.values(get(state, 'archivedHierarchyItems.data')) || {};

export const getArchivedHierarchyItemsFetchingData = state =>
  Object.values(get(state, 'archivedHierarchyItems.fetchingData')) || {};

export const getArchivedHierarchyItemsFetchError = state =>
  Object.values(get(state, 'archivedHierarchyItems.fetchDataError')) || {};
